<template>
  <div class="side-menus">
    <div class="controls" v-on:click="close">
      <img class="side-menu-image" src="@/assets/close_w.png" />
    </div>
    <div class="menus">
      <router-link class="link link-white unerline mb-48" to="/">TOP</router-link>
      <router-link class="link link-white unerline mb-48" to="/aboutUs">ABOUT US</router-link>
      <router-link class="link link-white unerline mb-48" to="/brandlist">BRAND LIST</router-link>
      <router-link class="link link-white unerline mb-48" to="/affiliate">AFFILIATE</router-link>
      <router-link class="link link-white unerline mb-48" to="/recruit">RECRUIT</router-link>
      <router-link class="link link-white unerline" to="/contact">CONTACT</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SideMenu',
  props: {
    isWhite: Boolean
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.side-menus {
  height: 100vh;
  background: rgba(96, 96, 96, 0.8);
  padding: 0 96px 0 112px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@supports (-webkit-touch-callout: none) {
  .side-menus {
    /* Safari用のハック */
    height: -webkit-fill-available;
  }
}
.controls {
  position: absolute;
  top: 48px;
  right: 64px;
}
.menus {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
}
.side-menu-image {
  width: 28px;
  height: 28px;
}
.link {
  font-size: 13px;
  letter-spacing: 4.5px;
  color: #000;
}
.link-white {
  color: #fff;
}
.link-white:visited {
  color: #fff;
}
.link-white:active {
  color: #fff;
}
.link-black {
  color: #000;
}
.link-black:visited {
  color: #000;
}
.link-black:active {
  color: #000;
}
.unerline {
  text-decoration: underline;
}
.mb-48 {
  margin-bottom: 48px;
}
@media (max-width: 639px) {
  .side-menus {
    padding: 0 64px 0 96px;
  }
  .controls {
    top: 24px;
    right: 24px;
  }
  .side-menu-image {
    width: 22px;
    height: 22px;
  }
  .link {
    letter-spacing: 3.5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/SideMenu.vue